export default __webpack_public_path__ + "static/media/office2-afterA-2048w.c7bf94e4.avif";